export default function NotFound() {
  return <main className="simple-page container"><span className="eyebrow">404 · PAGE NOT FOUND</span><h1>Looks like this little path wandered off.</h1><p>Let's get you back to Minrose.</p><a className="button button-dark" href="/">Back to home →</a></main>;
}